module.exports = __webpack_public_path__ + "5bf89c898ef342edf4f48c959046c449.svg";